import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';

var Footer = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Footer, _React$Component);

  function Footer() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Footer.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("footer", {
      className: "footer"
    }, this.props.infoList.map(function (item, index) {
      var linkUrl = item.linkUrl,
          title = item.title;
      return /*#__PURE__*/React.createElement("span", {
        className: "info",
        key: "footer-info-" + index
      }, /*#__PURE__*/React.createElement("a", {
        href: linkUrl,
        target: "_blank",
        rel: "noreferrer noopener"
      }, title));
    }));
  };

  return Footer;
}(React.Component);

export default Footer;